import ApiService from "@/core/services/api.service";
import { BaseService } from "@/components/Tools/baseService";

let url = process.env.VUE_APP_API_ADMIN;

const defaultFields = [
  "id",
  "children",
  "label",
  "process",
  "type",
  "process.id",
  "process.name",
  "process.workflow_id",
  "process.is_active",
  "process.schedule_method",
  "process.schedule_config",
  "process.last_run",
  "process.last_execution_status",
  "process.new_flow_editor_only",
  "process.queue_name",
  "process.workflow",
  "workflow.id",
  "workflow.name",
  "workflow.updated_at",
  "workflow.updated_by_user",
  "updated_by_user.full_name"
];

class FlowTableEntries extends BaseService {
  getAll(params, filter = [], fields = defaultFields) {
    let filterParams = this.getParams(filter, {}, fields);
    let searchParams = new URLSearchParams(params);

    let options = "?" + searchParams.toString();
    if (options === "?") {
      filterParams = filterParams.substring(1);
    }
    return ApiService.get(url, "flow_table_entries" + options + filterParams);
  }
  order(data) {
    return ApiService.put(url + "/flow_table_entries/order", data);
  }
  put(data) {
    let slug = "/flow_table_entries/";
    return ApiService.put(url + slug + data.id, data);
  }
  remove(id) {
    return ApiService.delete(url + "/flow_table_entries/" + id);
  }
  create(project_id, label) {
    return ApiService.post(
      url + "/flow_table_entries/createGroup",
      project_id,
      label
    );
  }
}
export default new FlowTableEntries();
